/* ============================================
   GLOW Skincare — Split-Lines Text Reveal (Phase D)
   Splits headings into visual lines and reveals
   them one-by-one with a clip+slide animation.
   No dependencies, respects reduced motion.
   
   NOTE: This script only SPLITS the text.
   The REVEAL is triggered by scroll-reveal.js
   when the parent section enters viewport.
   ============================================ */
(function() {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ---- Configuration ---- */
  var HEADING_SELECTORS = [
    '[id*="featured_collection"] .section__title, [id*="featured_collection"] .section__heading, [id*="featured_collection"] h2',
    '[id*="skin_diagnostic"] .section__title, [id*="skin_diagnostic"] .section__heading, [id*="skin_diagnostic"] h2',
    '[id*="testimonials"] .section__title, [id*="testimonials"] .section__heading, [id*="testimonials"] h2',
    '[id*="collections_concern"] .section__title, [id*="collections_concern"] .section__heading, [id*="collections_concern"] h2',
    '[id*="brand_innovation"] .section__title, [id*="brand_innovation"] .section__heading, [id*="brand_innovation"] h2',
    '[id*="guarantees"] .section__title, [id*="guarantees"] .section__heading, [id*="guarantees"] h2',
    '[id*="newsletter_incentive"] .section__title, [id*="newsletter_incentive"] .section__heading, [id*="newsletter_incentive"] h2'
  ];

  /* ---- Line Detection ---- */
  function getVisualLines(el) {
    var text = el.textContent.trim();
    if (!text) return [];

    var originalHTML = el.innerHTML;
    var words = text.split(/\s+/);
    el.innerHTML = words.map(function(w) {
      return '<span class="glow-sl-word" style="display:inline">' + w + '</span>';
    }).join(' ');

    var wordSpans = el.querySelectorAll('.glow-sl-word');
    var lines = [];
    var currentLine = [];
    var lastTop = null;

    wordSpans.forEach(function(span) {
      var top = Math.round(span.getBoundingClientRect().top);
      if (lastTop === null || Math.abs(top - lastTop) < 3) {
        currentLine.push(span.textContent);
      } else {
        lines.push(currentLine.join(' '));
        currentLine = [span.textContent];
      }
      lastTop = top;
    });

    if (currentLine.length > 0) lines.push(currentLine.join(' '));
    el.innerHTML = originalHTML;
    return lines;
  }

  /* ---- DOM Rewrite ---- */
  function applyLineSplit(el) {
    var lines = getVisualLines(el);
    if (lines.length === 0) return false;

    var frag = document.createDocumentFragment();
    lines.forEach(function(lineText) {
      var mask = document.createElement('span');
      mask.className = 'glow-split-mask';
      var inner = document.createElement('span');
      inner.className = 'glow-split-line';
      inner.textContent = lineText;
      mask.appendChild(inner);
      frag.appendChild(mask);
    });

    el.textContent = '';
    el.appendChild(frag);
    el.classList.add('glow-split-lines');
    return true;
  }

  /* ---- Init: split all target headings ---- */
  function init() {
    var processed = [];
    var fullSelector = HEADING_SELECTORS.join(', ');
    var els = document.querySelectorAll(fullSelector);
    
    els.forEach(function(el) {
      if (processed.indexOf(el) !== -1) return;
      if (el.closest('.glow-split-lines')) return;
      if (applyLineSplit(el)) processed.push(el);
    });
  }

  /* Wait for fonts and layout */
  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }

  /* ---- Resize handler ---- */
  var resizeTimer;
  var lastWidth = window.innerWidth;
  window.addEventListener('resize', function() {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      document.querySelectorAll('.glow-split-lines').forEach(function(el) {
        var text = '';
        el.querySelectorAll('.glow-split-line').forEach(function(line) {
          text += (text ? ' ' : '') + line.textContent;
        });
        el.textContent = text;
        el.classList.remove('glow-split-lines');
      });
      init();
      /* Reveal already-visible elements immediately */
      document.querySelectorAll('.glow-split-lines').forEach(function(el) {
        var section = el.closest('.glow-reveal');
        if (section && section.classList.contains('is-revealed')) {
          el.querySelectorAll('.glow-split-line').forEach(function(l) {
            l.classList.add('is-revealed');
          });
        }
      });
    }, 300);
  });
})();
